import {
  MAutocomplete,
  MDatePicker,
  MTextField,
  ResponsiveFormContainer,
} from "@app/components";
import useAuth from "@app/context/AuthContext";
import useFilterSamplingProcedure from "@app/hooks/useFilterSamplingProcedure";
import { formatDateOrNow } from "@app/utils/formatDate";
import { Grid, InputAdornment, Typography } from "@mui/material";
import {
  useEquipment,
  useReagents,
  useUser,
} from "@services/servicesGenericsTables";
import dayjs from "dayjs";
import React, { useEffect } from "react";
import { useFormContext } from "react-hook-form";

const Evaporation = () => {
  const form = useFormContext();
  const filterSamplingProcedureList = useFilterSamplingProcedure("EVAP");
  const { reagentsList } = useReagents();
  const { equipmentList } = useEquipment();
  const { userList } = useUser();
  const { user } = useAuth();

  useEffect(() => {
    if (!form.getValues("processing_analyst_evaporation")) {
      form.setValue("processing_analyst_evaporation", user);
    }

    if (!form.getValues("processing_date_time_evaporation")) {
      form.setValue("processing_date_time_evaporation", formatDateOrNow());
    }
    if (!form.getValues("processing_procedure_evaporation")) {
      form.setValue(
        "processing_procedure_evaporation",
        filterSamplingProcedureList[0] || undefined
      );
    }
  }, []);

  return (
    <>
      <Grid item xs={12} my={2}>
        <Typography variant="tagText">{"Evaporación"}</Typography>
      </Grid>
      <ResponsiveFormContainer columns={5} mt={1}>
        <MAutocomplete
          key={JSON.stringify(form.getValues("processing_analyst_evaporation"))}
          name="processing_analyst_evaporation"
          options={userList}
          label="Seleccione un analista"
          getOptionLabel={(option) => option.username || ""}
          validation={{ required: "El analista es requerido" }}
        />
        <MAutocomplete
          key={JSON.stringify(
            form.getValues("processing_procedure_evaporation")
          )}
          name="processing_procedure_evaporation"
          options={filterSamplingProcedureList}
          label="Procedimiento MLPMA"
          getOptionLabel={(option) => `${option.numop}` || ""}
          validation={{
            required:
              filterSamplingProcedureList.length > 0
                ? "El procedimiento MLPMA es requerido"
                : false,
          }}
        />
        <MAutocomplete
          key={JSON.stringify(
            form.getValues("processing_equipment_evaporation")
          )}
          name="processing_equipment_evaporation"
          options={equipmentList}
          label="Seleccione un Equipo"
          getOptionLabel={(option) =>
            `${option.codigo} - ${option.descripcion}` || ""
          }
          validation={{ required: "El equipo es requerido" }}
          multiple={true}
        />

        <MAutocomplete
          key={JSON.stringify(form.getValues("processing_reagent_evaporation"))}
          name="processing_reagent_evaporation"
          options={reagentsList.filter(
            (reagent) =>
              reagent.end_date_use === null && reagent.start_date_use != null
          )}
          label="Seleccione un Reactivo"
          getOptionLabel={(option) =>
            `${option.name}${
              option.number_lot ? ` - ${option.number_lot}` : ""
            } ${option.reactive_number ? ` - ${option.reactive_number}` : ""}
          ${!option.number_lot && !option.reactive_number ? ` - Sin lote` : ""}`
          }
        />

        <MDatePicker
          name="processing_date_time_evaporation"
          pickerType="datetime"
          label="Fecha y hora Inicio"
          validation={{ required: "La fecha y hora de inicio es requerida" }}
          maxDate={
            dayjs(form.watch("processing_date_time_end_evaporation")) || null
          }
        />
        <MDatePicker
          name="processing_date_time_end_evaporation"
          pickerType="datetime"
          label="Fecha y hora Fin"
          minDate={
            dayjs(form.watch("processing_date_time_evaporation")) || null
          }
        />
        <MTextField
          key={JSON.stringify(form.getValues("sample_volume_evaporation"))}
          name="sample_volume_evaporation"
          placeholder="Volumen muestra"
          label="Volumen muestra"
          type="number"
          fullWidth
        />
      </ResponsiveFormContainer>
    </>
  );
};

export default Evaporation;
